import { useState, useEffect } from 'react';
import { useCommunities, Community } from './useCommunities';

export type CommunityType = 'Farmers Markets' | 'Growing Style' | 'Associations';

export const useCommunitiesByType = () => {
  const { communities, loading, error, refetch } = useCommunities();
  const [communitiesByType, setCommunitiesByType] = useState<Record<CommunityType, Community[]>>({
    'Farmers Markets': [],
    'Growing Style': [],
    'Associations': []
  });

  useEffect(() => {
    console.log('🏠 useCommunitiesByType - All communities:', communities.length);

    const normalizeType = (t?: string | null): CommunityType | null => {
      if (!t) return null;
      const norm = t.toLowerCase().replace(/'/g, "").trim();
      if (norm === 'farmers markets' || norm === 'farmer s markets') return 'Farmers Markets';
      if (norm === 'growing styles' || norm === 'growing style') return 'Growing Style';
      if (norm === 'associations' || norm === 'association') return 'Associations';
      return null;
    };

    const grouped = communities.reduce((acc, community) => {
      const mapped = normalizeType(community["Community Type"] as string | null);
      if (mapped) {
        if (!acc[mapped]) acc[mapped] = [] as Community[];
        acc[mapped].push(community);
      }
      return acc;
    }, {} as Record<CommunityType, Community[]>);

    console.log('🏠 useCommunitiesByType - Grouped:', Object.fromEntries(Object.entries(grouped).map(([k,v]) => [k, v.length])));

    setCommunitiesByType({
      'Farmers Markets': grouped['Farmers Markets'] || [],
      'Growing Style': grouped['Growing Style'] || [],
      'Associations': grouped['Associations'] || []
    });
  }, [communities]);

  return {
    communitiesByType,
    allCommunities: communities,
    loading,
    error,
    refetch
  };
};